import { render, staticRenderFns } from "./ExpiredLink.vue?vue&type=template&id=c6eb7f06&scoped=true&"
import script from "./ExpiredLink.vue?vue&type=script&lang=js&"
export * from "./ExpiredLink.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredLink.vue?vue&type=style&index=0&id=c6eb7f06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6eb7f06",
  null
  
)

export default component.exports